import * as React from "react";

function SvgComScore(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 59.9 54.7"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <path
        d="M362.1 42.3c.1.1.2.2.2.3 0 .2 0 .2-.1.3-.1.1-.3.1-.5.1h-.4v-.8h.4c.1 0 .3 0 .4.1zm-1.4-.4v2.6h.5v-1.1h.5l.5 1.1h.5l-.6-1.2c.2 0 .3-.1.4-.2.1-.1.1-.3.1-.5s-.1-.4-.3-.5c-.2-.1-.4-.2-.8-.2h-.8zm2.7 2.1c-.1.2-.2.4-.4.6-.2.2-.4.3-.7.4-.2.1-.5.2-.8.2-.2 0-.5-.1-.7-.2-.2-.1-.4-.2-.6-.4-.2-.2-.3-.4-.4-.6-.1-.2-.1-.5-.1-.7 0-.3 0-.5.1-.8.1-.2.3-.5.5-.7.2-.2.4-.3.6-.4.2-.1.5-.1.8-.1.3 0 .5.1.8.1.2.1.4.2.6.4.2.2.3.4.4.6.1.2.1.5.1.8 0 .3-.1.6-.2.8zm-2.7-2.9c-.3.1-.5.3-.7.5-.2.2-.4.5-.5.8-.1.3-.2.6-.2.9 0 .3.1.6.2.9.1.3.3.5.5.7.2.2.5.4.7.5.3.1.6.2.9.2.3 0 .6-.1.9-.2.3-.1.5-.3.7-.5.2-.2.4-.4.5-.7.1-.3.2-.6.2-.9 0-.3-.1-.6-.2-.9-.1-.3-.3-.5-.5-.7-.2-.2-.5-.4-.7-.5-.3-.1-.6-.2-.9-.2-.3-.1-.6 0-.9.1z"
        fill="#444"
      />
      <path
        d="M39.6 37.3V19.2c0-1.5-1.3-2.7-2.8-2.5L2.2 20.8C1 21 0 22 0 23.3V46c0 1.2.9 2.3 2.1 2.5l34.6 6.1c1.6.3 3-.9 3-2.5v-9.5l-5.3-.4v7.2L3.7 44.9V24.4l30.7-2.5v15.2l5.2.2z"
        fill="#f47a0b"
      />
      <path
        d="M56 .1L10.9 9.9c-1.2.3-2.1 1.3-2.1 2.6V20l4.4-.5v-5.9l40.2-7.3v31.5l-40.2-1.7V23.6l-4.4.4v13.6c0 1.4 1 2.5 2.4 2.6L56.4 44c1.5.1 2.8-1.1 2.8-2.6V2.6C59.2.9 57.6-.3 56 .1z"
        fill="#00a4e0"
      />
    </svg>
  );
}

export default React.forwardRef(SvgComScore);
